// src/registry/remoteMap.ts
//
// Single source of truth for all federated remote imports.
// When adding a new remote, add ONE entry here — that's it.

import type { ComponentType } from "react";
import type { NavManifest } from "./appRegistry";

export interface RemoteImports {
  App: () => Promise<{ default: ComponentType }>;
  NavConfig: () => Promise<{ default: NavManifest }>;
}

// Import paths must be static strings — Module Federation resolves them at build time.
export const REMOTE_MAP: Record<string, RemoteImports> = {
  ingestion_manager: {
    App: () => import("ingestion_manager/App"),
    NavConfig: () => import("ingestion_manager/NavConfig"),
  },
  cohort_dashboard: {
    App: () => import("cohort_dashboard/App"),
    NavConfig: () => import("cohort_dashboard/NavConfig"),
  },
  ai_manager: {
    App: () => import("ai_manager/App"),
    NavConfig: () => import("ai_manager/NavConfig"),
  },
  model_dashboard: {
    App: () => import("model_dashboard/App"),
    NavConfig: () => import("model_dashboard/NavConfig"),
  },
};
